import { Injectable } from '@angular/core';
import { IMomentService } from './imoment.service';

@Injectable({ providedIn: 'root' })
export class MomentService implements IMomentService {
  //depends on script tag in index.html which put moment on the window object
  // <!--moment.js-->
  //<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.20.1/moment.min.js" > </script>

  public constructor() {}

  public getMoment = (): any => {
    let momentObject1 = window['moment']();
    return momentObject1;
  };

  public getMomentByDate = (dte: Date): any => {
    let momentObject2 = window['moment'](new Date(dte.getFullYear(), dte.getMonth(), dte.getDate()));
    return momentObject2;
  };
  public getMomentByObject = (obj: any): any => {
    let momentObject3 = window['moment'](obj);
    return momentObject3;
  };
  public getMomentByDateTime = (dte: Date): any => {
    let momentObject2 = window['moment'](
      new Date(dte.getFullYear(), dte.getMonth(), dte.getDate(), dte.getHours(), dte.getMinutes(), dte.getSeconds())
    );
    return momentObject2;
  };
}
